import React from "react";

type FilterPanelProps = {
  minPrice: string;
  maxPrice: string;
  minYear: string;
  maxYear: string;
  onChange: (field: string, value: string) => void;
  onReset: () => void;
};

const FilterPanel: React.FC<FilterPanelProps> = ({
  minPrice,
  maxPrice,
  minYear,
  maxYear,
  onChange,
  onReset,
}) => (
  <div className="fixed top-20 left-0 z-40 bg-white border-r border-gray-200 shadow h-[80vh] w-64 p-6 flex flex-col gap-6">
    <div className="font-bold text-lg mb-2">필터</div>
    <div className="flex flex-col gap-2">
      <label className="text-sm font-semibold">가격(만원)</label>
      <div className="flex gap-2 items-center">
        <input
          type="number"
          min={0}
          value={minPrice}
          onChange={(e) => onChange("minPrice", e.target.value)}
          placeholder="최소"
          className="w-20 px-2 py-1 border rounded text-sm"
        />
        <span>~</span>
        <input
          type="number"
          min={0}
          value={maxPrice}
          onChange={(e) => onChange("maxPrice", e.target.value)}
          placeholder="최대"
          className="w-20 px-2 py-1 border rounded text-sm"
        />
      </div>
    </div>
    <div className="flex flex-col gap-2">
      <label className="text-sm font-semibold">건설연도</label>
      <div className="flex gap-2 items-center">
        <input
          type="number"
          min={1900}
          value={minYear}
          onChange={(e) => onChange("minYear", e.target.value)}
          placeholder="최소"
          className="w-20 px-2 py-1 border rounded text-sm"
        />
        <span>~</span>
        <input
          type="number"
          min={1900}
          value={maxYear}
          onChange={(e) => onChange("maxYear", e.target.value)}
          placeholder="최대"
          className="w-20 px-2 py-1 border rounded text-sm"
        />
      </div>
    </div>
    <button
      onClick={onReset}
      className="mt-4 px-3 py-1 rounded bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm border border-gray-300"
      type="button"
    >
      필터 초기화
    </button>
  </div>
);

export default FilterPanel;
